<template>
  <div :class="['signup-box', { 'compact-mode': compact }]">
    <!-- 完整页面模式：显示背景和导航 -->
    <div v-if="!compact" class="content-box">
      <div class="img-bg">
        <div class="bg-pattern"></div>
      </div>
      <div class="back-btn">
        <i class="el-icon-back" @click="goBack"></i>
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">Home</el-breadcrumb-item>
          <el-breadcrumb-item>
            <span style="cursor:default;font-weight: 600;color:#09CA6A;">Sign Up</span>
          </el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>

    <div v-if="!compact" class="bg-box"></div>

    <div :class="['form-box', { 'compact-form': compact }]">
      <!-- 完整页面模式：显示关闭按钮 -->
      <div v-if="!compact" class="top-box"> 
        <a @click="goBack" class="close">
          <i class="el-icon-close"></i>
        </a>
      </div>

      <div class="slide-box">
        <!-- 注册表单 -->
        <div style="width:100%;">
          <div>
            <h2>Create your account</h2>
            
            <!-- 姓名输入 -->
            <div class="name-input-box">
              <div class="input-box">
                <div class="shadow-box" :class="{ 'error': formErrors.firstName }">
                  <input 
                    class="input" 
                    v-model="form.firstName" 
                    placeholder="First Name" 
                    type="text"
                  />
                </div>
              </div>
              <div class="input-box">
                <div class="shadow-box" :class="{ 'error': formErrors.lastName }">
                  <input 
                    class="input" 
                    v-model="form.lastName" 
                    placeholder="Last Name" 
                    type="text"
                  />
                </div>
              </div>
            </div>
            <!-- 姓名错误提示 -->
            <div class="name-error-box" v-if="formErrors.firstName || formErrors.lastName">
              <div v-if="formErrors.firstName" class="error-message-row name-error">{{ formErrors.firstName }}</div>
              <div v-if="formErrors.lastName" class="error-message-row name-error">{{ formErrors.lastName }}</div>
            </div>

            <!-- 邮箱输入 -->
            <div class="input-box">
              <div class="shadow-box full-width" :class="{ 'error': formErrors.email }">
                <input 
                  class="input" 
                  v-model="form.email" 
                  placeholder="Email address" 
                  type="email"
                />
              </div>
            </div>
            <div v-if="formErrors.email" class="error-message-row">{{ formErrors.email }}</div>

            <!-- 密码输入 -->
            <div class="input-box">
              <div class="shadow-box full-width" :class="{ 'error': formErrors.password }">
                <input 
                  class="input" 
                  v-model="form.password" 
                  :type="showPassword ? 'text' : 'password'"
                  placeholder="Password (at least 6 characters)"
                />
                <i 
                  class="el-icon-view password-toggle"
                  :class="{ 'show': showPassword }"
                  @click="showPassword = !showPassword"
                ></i>
              </div>
            </div>
            <div v-if="formErrors.password" class="error-message-row">{{ formErrors.password }}</div>

            <!-- 邀请码输入 -->
            <!-- <div class="input-box">
              <div class="shadow-box full-width">
                <input 
                  class="input" 
                  v-model="form.invitationCode" 
                  placeholder="Invitation Code (optional)" 
                  type="text" 
                />
              </div>
            </div> -->

            <!-- 手机号输入 -->
            <div class="input-box">
              <div class="area-box">
                <PhoneBtn v-model="form.code"></PhoneBtn>
              </div>
              <div class="shadow-box" :class="{ 'error': formErrors.phone }">
                <input 
                  class="input" 
                  v-model="form.phone" 
                  @keyup="form.phone=form.phone.replace(/\D/g,'')" 
                  placeholder="phone number" 
                  type="phone"
                />
              </div>
            </div>
            <div v-if="formErrors.phone" class="error-message-row">{{ formErrors.phone }}</div>

            <!-- 验证码输入 -->
            <div class="input-box">
              <div class="shadow-box" style="flex: 1; margin-right: 10px;" :class="{ 'error': formErrors.verCode }">
                <input 
                  class="input" 
                  v-model="form.verCode" 
                  @keyup="form.verCode=form.verCode.substring(0,4)" 
                  placeholder="Verification Code" 
                  type="text"
                />
              </div>
              <div 
                :class="['send-code-btn', { 'disabled': !canSendCode || sendCodeLoading }]"
                @click="sendVerificationCode"
              >
                <i v-if="sendCodeLoading" class="el-icon-loading" style="margin-right: 4px;"></i>
                {{ sendCodeText }}
              </div>
            </div>
            <div v-if="formErrors.verCode" class="error-message-row">{{ formErrors.verCode }}</div>

            <div :class="['check-box',{'shaking': showAgreeAnimation}]">
              <el-checkbox size="medium" v-model="agree"></el-checkbox>
              <span @click="agree=!agree">Agree</span>
              <p>
                By submitting your information, you agree to All Eat App's 
                <a href="/termsConditions" class="under-line">Terms & Conditions, </a>
                <a href="/faqs" class="under-line">Privacy Policy & Cookies Policy.</a>
              </p>
            </div>

            <div 
              :class="['sign-btn','flex-row-center',{'disable-btn':!canSignup || signupLoading}]" 
              @click="handleSignup"
            >
              <i v-if="signupLoading" class="el-icon-loading" style="margin-right: 8px;"></i>
              {{ signupLoading ? 'Creating Account...' : 'Sign Up' }}
            </div>
            
            <!-- 已有账号提示 -->
            <!-- <div class="login-link-container">
              <span>Already have an account? </span>
              <span class="login-link" @click="goToLogin">Sign In</span>
            </div> -->
          </div>
        </div>
      </div>

    </div>

    <!-- Cloudflare 验证弹层 -->
    <div v-if="showCloudflare && $cloudflareVerify" class="cloudflare-modal">
      <div class="cloudflare-overlay" @click="closeCloudflare"></div>
      <div class="cloudflare-content">
        <div class="cloudflare-header">
          <h3>Security Verification</h3>
          <button class="close-btn" @click="closeCloudflare">
            <i class="el-icon-close"></i>
          </button>
        </div>
        <CloudflareVerify 
          style="padding: 20px;" 
          ref="cloudflare"
          @token-received="onTokenReceived"
        ></CloudflareVerify>
      </div>
    </div>

    <!-- 验证码滑块模块 -->
    <Verify 
      v-if="!$cloudflareVerify"
      @success="sendcodeMsg"
      :mode="'pop'"
      :captchaType="'blockPuzzle'"
      :imgSize="{ width: '330px', height: '155px' }"
      ref="verify"
    ></Verify>
  </div>
</template>

<script>
/* eslint-disable */
import { postGateway } from '@/request';
import PhoneBtn from '@/components/PhoneBtn.vue';
import Verify from '@/components/Verifition/Verify';
import CloudflareVerify from '@/components/CloudFlareVerify.vue';
import bus from '@/utils/bus.js';
import loginMixin from '@/mixins/loginMixin.js';

export default {
  name: "SignupForm",
  mixins: [loginMixin],
  components: {
    PhoneBtn,
    Verify,
    CloudflareVerify
  },
  props: {
    fromPage: {
      type: String,
      default: null
    },
    compact: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      signupLoading: false,
      sendCodeLoading: false,
      showPassword: false,
      showAgreeAnimation: false,
      agree: false,
      timer: null,
      countdown: 0,
      showCloudflare: false,
      cloudflareToken: null,
      sendMsgTimes: 0,
      // 表单数据
      form: {
        firstName: '',
        lastName: '',
        email: '',
        password: '',
        phone: '',
        code: '+44',
        verCode: '',
        invitationCode: ''
      },
      // 表单验证状态
      formErrors: {
        firstName: '',
        lastName: '',
        email: '',
        password: '',
        phone: '',
        verCode: ''
      },
    }
  },
  computed: {
    canSignup() {
      return this.form && 
             this.form.firstName && this.form.firstName.trim() && 
             this.form.lastName && this.form.lastName.trim() && 
             this.form.email && this.form.email.trim() && 
             this.form.password && this.form.password.trim() && 
             this.form.phone && this.form.phone.trim() && 
             this.form.verCode && this.form.verCode.trim() && 
             this.agree &&
             !this.hasFormErrors;
    },
    canSendCode() {
      return this.form && this.form.phone && this.form.phone.trim() && this.countdown === 0;
    },
    sendCodeText() {
      if (this.sendCodeLoading) {
        return 'Sending...';
      }
      if (this.countdown > 0) {
        return `${this.countdown}s`;
      }
      if (!this.form || !this.form.phone || !this.form.phone.trim()) {
        return 'Enter Phone';
      }
      return 'Send Code';
    },
    hasFormErrors() {
      return Object.values(this.formErrors).some(error => error !== '');
    }
  },
  methods: {
    // 表单验证
    validateForm() {
      this.clearFormErrors();
      let isValid = true;

      // 检查form对象是否存在
      if (!this.form) {
        return false;
      }

      // 验证姓名
      if (!this.form.firstName || !this.form.firstName.trim()) {
        this.formErrors.firstName = 'Please enter your first name';
        isValid = false;
      }
      if (!this.form.lastName || !this.form.lastName.trim()) {
        this.formErrors.lastName = 'Please enter your last name';
        isValid = false;
      }

      // 验证邮箱
      if (!this.form.email || !this.form.email.trim()) {
        this.formErrors.email = 'Please enter your email';
        isValid = false;
      } else if (!this.isValidEmail(this.form.email)) {
        this.formErrors.email = 'Please enter a valid email address';
        isValid = false;
      }

      // 验证密码
      if (!this.form.password || !this.form.password.trim()) {
        this.formErrors.password = 'Please enter your password';
        isValid = false;
      } else if (this.form.password.length < 6) {
        this.formErrors.password = 'Password must be at least 6 characters';
        isValid = false;
      }

      // 验证手机号
      if (!this.form.phone || !this.form.phone.trim()) {
        this.formErrors.phone = 'Please enter your phone number';
        isValid = false;
      }

      // 验证验证码
      if (!this.form.verCode || !this.form.verCode.trim()) {
        this.formErrors.verCode = 'Please enter verification code';
        isValid = false;
      }

      return isValid;
    },

    // 清除表单错误
    clearFormErrors() {
      this.formErrors = {
        firstName: '',
        lastName: '',
        email: '',
        password: '',
        phone: '',
        verCode: ''
      };
    },

    // 邮箱格式验证
    isValidEmail(email) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(email);
    },

    // 发送验证码
    async sendVerificationCode() {
      if (!this.canSendCode || this.sendCodeLoading) return;

      if (!this.form || !this.form.phone || !this.form.phone.trim()) {
        this.$message({
          message: 'Please enter your phone number',
          type: 'warning',
          offset: 50
        });
        return;
      }

      // 校验手机号是否重复国家代码
      if (!this.validatePhoneNumberFormat()) {
        return;
      }

      // 根据配置选择验证方式
      if (this.$cloudflareVerify) {
        // 使用 Cloudflare 验证
        this.showCloudflare = true;
      } else {
        // 使用滑块验证
        this.$refs.verify.show();
      }
    },

    // 校验手机号是否重复国家代码（仅针对 +44 和 +353）
    validatePhoneNumberFormat() {
      const phoneNumber = this.form.phone.trim();
      
      // 只处理 +44 和 +353 的情况
      if (this.form.code === '+44' && phoneNumber.startsWith('44')) {
        this.$message({
          message: "Please remove the country code '44' from the phone number",
          type: 'warning',
          offset: 50
        });
        return false;
      }
      
      if (this.form.code === '+353' && phoneNumber.startsWith('353')) {
        this.$message({
          message: "Please remove the country code '353' from the phone number",
          type: 'warning',
          offset: 50
        });
        return false;
      }
      
      return true;
    },

    // 发送手机验证码（滑块验证回调或 Cloudflare 回调）
    async sendcodeMsg({ captchaVerification }) {
      // 如果是 Cloudflare 验证，captchaVerification 可能是字符串 token
      const token = captchaVerification || this.cloudflareToken;
      if (!token) {
        return;
      }

      // 校验手机号格式
      if (!this.validatePhoneNumberFormat()) {
        this.sendCodeLoading = false;
        return;
      }

      try {
        this.sendCodeLoading = true;

        // 根据配置选择接口
        let url = this.$cloudflareVerify 
          ? '/customer/atClient/smsSendCloudFlare'
          : '/customer/atClient/smsSend';
        if (this.sendMsgTimes > 0) {
          url = this.$cloudflareVerify
            ? '/customer/atClient/smsSendTextlocalCloudFlare'
            : '/customer/atClient/smsSendTextlocal';
        }

        const response = await postGateway({
          url: url,
          method: 'POST',
          data: {
            phone: this.form.code + this.form.phone,
            captchaType: 'register',
            captchaVerification: token,
          }
        });

        if (response.code === 200) {
          // 发送成功，重置 Cloudflare 验证状态
          if (this.$cloudflareVerify) {
            this.cloudflareToken = null;
            this.showCloudflare = false;
          }

          // 开始倒计时
          this.startCountdown();

          // 增加发送次数
          this.sendMsgTimes++;

          this.$message({
            message: 'Verification code sent successfully!',
            type: 'success',
            offset: 50
          });

          // 自动focus到验证码输入框
          this.$nextTick(() => {
            const verCodeInput = this.$el.querySelector('input[placeholder="Verification Code"]');
            if (verCodeInput) {
              verCodeInput.focus();
            }
          });
        } else {
          // 发送失败，清除 Cloudflare token，下次需要重新验证
          if (this.$cloudflareVerify) {
            this.cloudflareToken = null;
            this.showCloudflare = false;
          }

          this.$message({
            message: response.msg || 'Failed to send verification code',
            type: 'error',
            offset: 50
          });
        }
      } catch (error) {
        // 网络错误，清除 Cloudflare token，下次需要重新验证
        if (this.$cloudflareVerify) {
          this.cloudflareToken = null;
          this.showCloudflare = false;
        }

        if(error.msg) {
          this.$message.error(error.msg);
        }
      } finally {
        this.sendCodeLoading = false;
      }
    },

    // 开始倒计时
    startCountdown() {
      this.countdown = 60;
      this.timer = setInterval(() => {
        this.countdown--;
        if (this.countdown <= 0) {
          clearInterval(this.timer);
          this.timer = null;
        }
      }, 1000);
    },

    // 处理注册
    async handleSignup() {
      if (!this.validateForm()) {
        this.$message({
          message: 'Please fill in all required fields correctly',
          type: 'warning',
          offset: 50
        });
        return;
      }

      if (!this.agree) {
        this.showAgreeAnimation = true;
        this.$message({
          message: 'Please agree to the terms and privacy policy',
          type: 'warning',
          offset: 50
        });
        setTimeout(() => {
          this.showAgreeAnimation = false;
        }, 1000);
        return;
      }

      try {
        this.signupLoading = true;

        // 构建注册数据，密码需要加密
        const registrationData = {
          firstName: this.form.firstName.trim(),
          lastName: this.form.lastName.trim(),
          passWord: this.$encryptByPublicKey(this.form.password.trim()),
          invitationCode: this.form.invitationCode.trim(),
          registrationType: 'mobile',
          captcha: this.form.verCode.trim(),
          email: this.form.email.trim(),
          phone: this.form.code + this.form.phone,
        };

        const response = await postGateway({
          url: '/customer/atClient/register',
          method: 'POST',
          data: registrationData
        });

        if (response.code == 200) {
          // 注册成功，保存用户信息
          localStorage.setItem('token', response.data.token);
          localStorage.setItem('refreshToken', response.data.refreshToken);
          localStorage.setItem('clientId', response.data.clientId);
          localStorage.setItem('aeClient', response.data.clientId);

          console.log(response.data,'response.data')
          

          this.$message({
            message: 'Registration successful!',
            type: 'success',
            offset: 50
          });

            // 根据来源页面决定处理逻辑
            setTimeout(() => {
             // 通知header登录了
             bus.$emit('login');
              if (this.fromPage === 'checkout' || this.compact) {
                // 如果是从checkout页面来的或者是紧凑模式（组件使用），发出事件让父组件处理
                this.$emit('signupSuccess');
              } else {
                // 如果是独立页面使用，才进行路由控制
                if (this.fromPage === 'login') {
                  // 如果是从登录页面来的，回退两个路由（注册页面 -> 登录页面 -> 上一个页面）
                  this.$router.go(-1);
                } else {
                  // 否则只回退一个路由
                  this.$router.go(-1);
                }
              }
            }, 1000);
        } else {
          let errorMsg = 'Registration failed';
          if (response.code === 50020) {
            errorMsg = 'The phone number has been registered';
          } else if (response.code === 50003) {
            errorMsg = 'The email has been registered';
          } else if (response.code === 50002) {
            errorMsg = 'Incorrect verification code';
          } else {
            errorMsg = response.msg || 'Registration failed';
          }
          if(response.code == 50021) {
            return
          }
          console.log(response,'response')
          this.$message({
            message: errorMsg,
            type: 'error',
            offset: 50
          });
        }
      } catch (error) {
        console.log(error,'error')
        this.$message({
          message: error && error.msg ? error.msg : 'Network error: ' + error,
          type: 'error',
          offset: 50
        });
      } finally {
        this.signupLoading = false;
      }
    },


    // 跳转到登录页面
    goToLogin() {
      this.$router.push('/login');
    },

    // 返回上一页
    goBack() {
      this.$router.go(-1);
    },

    // 关闭 Cloudflare 弹层
    closeCloudflare() {
      this.showCloudflare = false;
      this.cloudflareToken = null;
      this.sendCodeLoading = false; // 取消loading状态
    },

    // 接收 Cloudflare token
    onTokenReceived(token) {
      this.cloudflareToken = token;
      this.showCloudflare = false;
      this.sendcodeMsg({ captchaVerification: token });
    }
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  }
};
</script>

<style lang="scss" scoped>
$mainColor: #aa0bc0;
$greenColor: #26d07c;
$yellowColor: #ffa132;

.signup-box {
  min-height: 100vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  position: relative;

  .bg-box {
    flex: 1;
    // background: linear-gradient(135deg, #a8c8ec 0%, #4a90e2 50%, #87ceeb 100%);
    background-size: cover;
    background-position: center;
  }
  
  .back-btn {
    position: relative;
    background: #0A191E;
    height: 36px;
    border-radius: 18px;
    padding: 0 20px;
    font-weight: bold;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    margin: 30px 6% 0;
    cursor: pointer;
    
    .el-icon-back {
      color: #C2F93A;
      font-size: 22px;
      margin-right: 10px;
    }
    
    :deep(.el-breadcrumb__inner) {
      color: #fff;
    }
    :deep(.el-breadcrumb__separator) {
      color: #fff;
    }
  }

  .content-box {
    position: relative;
    width: 100%;
    height: 420px;
      .img-bg {
        position: absolute;
        z-index: 0;
        height: 420px;
        width: 100%;
        background: linear-gradient(135deg, #a8c8ec 0%, #4a90e2 50%, #87ceeb 100%);
        overflow: hidden;
      }

    .bg-pattern {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: 
        radial-gradient(circle at 20% 80%, rgba(120, 119, 198, 0.3) 0%, transparent 50%),
        radial-gradient(circle at 80% 20%, rgba(255, 119, 198, 0.3) 0%, transparent 50%),
        radial-gradient(circle at 40% 40%, rgba(120, 219, 255, 0.3) 0%, transparent 50%);
    }

    .decorative-element {
      position: absolute;
      z-index: 1;
      right: 6%;
      top: 20px;
      width: 200px;
      height: 200px;
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      border-radius: 50%;
      opacity: 0.8;
      box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
      
      &::before {
        content: '';
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 80px;
        height: 80px;
        background: rgba(255, 255, 255, 0.3);
        border-radius: 50%;
      }
    }
  } 

  .form-box {
    width: 520px;
    min-height: 420px;
    background: #fff;
    top: 8%;
    left: 50%;
    transform: translateX(-50%);
    border-radius: 16px;
    padding: 0 30px 20px;
    position: absolute;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);

    h2 {
      font-weight: 800;
      color: #000;
      font-size: 28px;
      text-align: center;
      margin-top: 0;
      margin-bottom: 6px;
    }
    p {
      font-size: 14px;
      text-align: center;
      margin: 0;
      color: #111;
      .under-line {
        text-decoration: underline;
        margin: 0;
        cursor: pointer;
        color: #2885e2;
      }
    }

    // 姓名输入框样式
    .name-input-box {
      display: flex;
      gap: 8px;
      margin-top: 15px;
      
      .input-box {
        flex: 1;
      }
    }

    .input-box {
      margin-top: 15px;
      display: flex;
      align-items: center;

      .area-box {
        height: 48px;
        width: 100px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
        margin-right: 8px;
        border-radius: 10px;
      }
      
      .input {
        height: 48px;
        flex: 1;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
        border-radius: 10px;
        padding-left: 16px;
        font-size: 16px;
        font-weight: 600;
        &::placeholder {
          font-weight: 500;
        }
      }
      
      .shadow-box {
        flex: 1;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
        border-radius: 10px;
        position: relative;
        
        &.full-width {
          flex: 1;
          margin-right: 0;
        }
        
        input {
          height: 48px;
          width: 100%;
          border: none;
          outline: none;
          padding-left: 16px;
          padding-right: 40px;
          font-size: 16px;
          font-weight: 600;
          background: transparent;
          &::placeholder {
            font-weight: 500;
          }
        }
        
        .password-toggle {
          position: absolute;
          right: 15px;
          top: 50%;
          transform: translateY(-50%);
          cursor: pointer;
          font-size: 18px;
          color: #999;
          transition: all 0.3s ease;
          
          &:hover {
            color: #666;
            transform: translateY(-50%) scale(1.1);
          }
          
          &:active {
            transform: translateY(-50%) scale(0.95);
          }
          
          &.show {
            color: #09ca6a;
            
            &:hover {
              color: #08b35e;
            }
          }
        }
        
        &.error {
          border: 1px solid #ff4757;
          box-shadow: 0 2px 8px rgba(255, 71, 87, 0.2);
        }
      }
    }
    
    // 错误消息样式
    .error-message {
      color: #ff4757;
      font-size: 12px;
      margin-top: 4px;
      margin-left: 4px;
      line-height: 1.2;
    }

    .error-message-row {
      color: #ff4757;
      font-size: 12px;
      margin-top: 4px;
      margin-bottom: 8px;
      text-align: left;
      width: 100%;
      display: block;
      line-height: 1.2;
    }

    .name-error-box {
      display: flex;
      gap: 10px;
      margin-top: 4px;
      margin-bottom: 8px;
    }

    .name-error {
      flex: 1;
      color: #ff4757;
      font-size: 12px;
      text-align: left;
      line-height: 1.2;
      margin: 0;
    }

    // 移动端姓名错误提示改为单行
    @media (max-width: 480px) {
      .name-error-box {
        flex-direction: column;
        gap: 4px;
      }
      
      .name-error {
        flex: none;
        width: 100%;
      }
    }

    // 发送验证码按钮
    .send-code-btn {
      height: 48px;
      padding: 0 16px;
      background-color: #09CA6A;
      color: #fff;
      font-size: 12px;
      font-weight: 600;
      border-radius: 10px;
      box-shadow: 0 2px 8px rgba(9, 202, 106, 0.3);
      transition: all 0.3s ease;
      cursor: pointer;
      border: none;
      outline: none;
      display: flex;
      align-items: center;
      justify-content: center;
      white-space: nowrap;
      min-width: 100px;
      
      &:hover:not(.disabled) {
        background-color: #0fda74;
        box-shadow: 0 4px 12px rgba(9, 202, 106, 0.4);
        transform: translateY(-1px);
      }
      
      &.disabled {
        background-color: #999;
        cursor: not-allowed;
        &:hover {
          background-color: #999;
          transform: none;
        }
      }
    }

    .check-box {
      margin-top: 15px;
      display: flex;
      font-size: 14px;
      padding-left: 0;
      display: flex;
      align-items: flex-start;
      flex-wrap: wrap;
    
      :deep(.el-checkbox__inner) {
        background-color: #DCDFE6;
      }
      :deep(.el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner) {
        background-color: #09CA6A;
        border-color: #09CA6A;
      }
      :deep(.el-checkbox__inner) {
        transform: scale(1.4);
      }
      span {
        margin-left: 15px;
        cursor: pointer;
      }
      p {
        margin-top: 10px;
        display: block;
        font-size: 14px;
        line-height: 20px;
        color: #474747;
        text-align: left;
        .under-line {
          text-decoration: underline;
          margin: 0;
          cursor: pointer;
          color: #2885e2;
        }
      }
    }
    
    @keyframes shakingAnimation {
      0% {
        transform: translateX(-3%); 
        color: red;
      }
      10% {
        transform: translateX(63); 
        color: red;
      }
      20% {
        transform: translateX(-2%); 
        color: red;
      }
      30% {
        transform: translateX(2%); 
        color: red;
      }
      40% {
        transform: translateX(-1%); 
        color: red;
      }
      50% {
        transform: translateX(1%); 
      }
    }
    
    .shaking {
      color: rgb(199, 12, 12);
      transform: translateX(0); 
      animation: shakingAnimation 1s ease-in-out forwards;
    }
    
    .sign-btn {
      margin: 15px auto 5px;
      height: 48px;
      width: 200px;
      background-color: #09CA6A;
      color: #fff;
      font-size: 14px;
      letter-spacing: 0.5px;
      font-weight: 600;
      border-radius: 24px;
      box-shadow: 0 4px 12px rgba(9, 202, 106, 0.3);
      transition: all .3s ease;
      cursor: pointer;
      border: none;
      outline: none;
      display: flex;
      align-items: center;
      justify-content: center;
      &:hover {
        background-color: #0fda74;
        box-shadow: 0 6px 20px rgba(9, 202, 106, 0.4);
        transform: translateY(-2px);
      }
      &:active {
        transform: translateY(0);
      }
    }
    
    .login-link-container {
      text-align: center;
      margin-top: 20px;
      font-size: 14px;
      color: #666;
      
      .login-link {
        color: #d22f21;
        font-weight: bold;
        cursor: pointer;
        text-decoration: underline;
        margin-left: 5px;
        
        &:hover {
          color: #b01e1a;
        }
      }
    }
    
    .disable-btn {
      background-color: #999;
      &:hover {
        background-color: #999;
        box-shadow: 0px 5px 10px #6f7577;
      }
    }
  }

  .top-box {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 20px;

    i {
      font-size: 26px;
      color: #000;
      cursor: pointer;
      transition: all ease-in .2s;
      text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25), 0px 4px 4px rgba(0, 0, 0, 0.25);
      &:hover {
        color: $mainColor;
      }
    }
    .close {
      position: relative;
      right: -40px;
    }
  }

  .slide-box {
    position: relative;
    padding: 0 30px;
  }
}

// Cloudflare 弹层样式
.cloudflare-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  box-sizing: border-box;
  
  .cloudflare-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.6);
    backdrop-filter: blur(4px);
  }
  
  .cloudflare-content {
    position: relative;
    background: #fff;
    border-radius: 16px;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.4);
    max-width: 480px;
    width: 100%;
    max-height: 85vh;
    overflow: hidden;
    animation: modalSlideIn 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
    transform-origin: center;
    
    .cloudflare-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 24px 28px;
      border-bottom: 1px solid #e9ecef;
      background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
      
      h3 {
        margin: 0;
        font-size: 20px;
        font-weight: 700;
        color: #2c3e50;
        display: flex;
        align-items: center;
      }
      
      .close-btn {
        background: none;
        border: none;
        font-size: 22px;
        color: #6c757d;
        cursor: pointer;
        padding: 8px;
        border-radius: 8px;
        transition: all 0.3s ease;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 36px;
        height: 36px;
        
        &:hover {
          background: #e9ecef;
          color: #495057;
          transform: scale(1.1);
        }
      }
    }
    
    // Cloudflare 组件容器
    :deep(.cloudflare-verify) {
      padding: 24px 28px 28px;
      text-align: center;
      
      .cloudflare-widget {
        margin: 0 auto;
        border-radius: 8px;
        overflow: hidden;
      }
    }
  }
}

@keyframes modalSlideIn {
  0% {
    opacity: 0;
    transform: scale(0.8) translateY(-30px);
  }
  50% {
    opacity: 0.8;
    transform: scale(1.05) translateY(-5px);
  }
  100% {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

// 中等屏幕适配 (平板)
@media screen and (max-width: 1200px) and (min-width: 951px) {
  .signup-box {
    .form-box {
      width: 480px;
      min-height: 400px;
      top: 6%;
      
      h2 {
        font-size: 24px;
      }
      
      .input-box {
        margin-top: 12px;
        
        .area-box {
          height: 44px;
          width: 120px;
        }
        
        .shadow-box input {
          height: 44px;
          font-size: 15px;
        }
      }
      
      .send-code-btn {
        height: 44px;
        min-width: 90px;
        font-size: 11px;
      }
      
      .sign-btn {
        height: 44px;
        width: 180px;
        font-size: 13px;
      }
    }
  }
}

// 移动端适配
@media screen and (max-width: 950px) {
  .signup-box {
    width: 100vw;
    .content-box {
      .back-btn {
        display: none;
      }
      .img-bg {
        height: 150px;
      }
      .decorative-element {
        width: 80px;
        height: 80px;
        right: 3%;
        top: 10px;
      }
    }
    .form-box {
      width: 92vw;
      min-height: 380px;
      top: 5%;
      padding: 0 20px 15px;
      
      .top-box {
        padding: 8px;
        .close {
          right: 0;
        }
      }
      
      .slide-box {
        padding: 0;
        h2 {
          font-size: 22px;
          margin-bottom: 4px;
        }
        p {
          font-size: 13px;
        }
        
        .name-input-box {
          flex-direction: column;
          gap: 0;
          margin-top: 12px;
        }
        
        .input-box {
          margin-top: 12px;
          
          .area-box {
            height: 44px;
            width: 85px;
            margin-right: 6px;
          }
          
          .shadow-box {
            input {
              height: 44px;
              font-size: 14px;
              padding-left: 12px;
              padding-right: 35px;
            }
          }
        }
        
        .send-code-btn {
          height: 44px;
          font-size: 11px;
          min-width: 85px;
          padding: 0 12px;
        }
        
        .check-box {
          padding-left: 0;
          margin-top: 12px;
          font-size: 12px;
          
          p {
            font-size: 11px;
            line-height: 16px;
          }
        }
        
        .sign-btn {
          width: 85%!important;
          margin: 12px auto 0!important;
          height: 44px;
          font-size: 13px;
        }
        
        .login-link-container {
          font-size: 12px;
          margin-top: 12px;
        }
      }
    }
  }
}

// 小屏幕手机适配
@media screen and (max-width: 480px) {
  .signup-box {
    .form-box {
      width: 95vw;
      min-height: 350px;
      top: 3%;
      padding: 0 15px 10px;
      
      h2 {
        font-size: 20px;
      }
      
      p {
        font-size: 12px;
      }
      
      .input-box {
        margin-top: 10px;
        
        .area-box {
          height: 40px;
          width: 75px;
        }
        
        .shadow-box input {
          height: 40px;
          font-size: 13px;
          padding-left: 10px;
          padding-right: 30px;
        }
      }
      
      .send-code-btn {
        height: 40px;
        min-width: 75px;
        font-size: 10px;
        padding: 0 8px;
      }
      
      .sign-btn {
        height: 40px;
        width: 90%!important;
        font-size: 12px;
      }
      
      .check-box {
        font-size: 11px;
        
        p {
          font-size: 10px;
          line-height: 14px;
        }
      }
    }
  }
}

// 紧凑模式样式
.signup-box.compact-mode {
  min-height: auto;
  width: 100%;
  display: block;
  
  .form-box.compact-form {
    width: 100%;
    min-height: auto;
    top: auto;
    left: auto;
    transform: none;
    border-radius: 0;
    padding: 0;
    box-shadow: none;
    position: relative;
    
    h2 {
      font-size: 24px;
      margin-bottom: 20px;
    }
    
    .input-box {
      margin-top: 15px;
      
      .area-box {
        height: 48px;
        width: 100px;
        margin-right: 8px;
      }
      
      .shadow-box input {
        height: 48px;
        font-size: 16px;
        padding-left: 16px;
        padding-right: 40px;
      }
    }
    
    .send-code-btn {
      height: 48px;
      min-width: 100px;
      font-size: 12px;
      padding: 0 16px;
    }
    
    .sign-btn {
      height: 48px;
      width: 100%;
      font-size: 16px;
      margin: 20px auto 0;
    }
    
    .check-box {
      margin-top: 15px;
      font-size: 14px;
      
      p {
        font-size: 12px;
        line-height: 18px;
      }
    }
    
    .login-link-container {
      margin-top: 15px;
      font-size: 14px;
    }
  }
}
</style>
